module.exports = __webpack_public_path__ + "static/media/CAP_Logo.b4e0edee.png";